import { gql, type OperationVariables } from '@apollo/client';
import { EEntityType } from '@sharedInterfaces/globalEnums';
import type IEmployeeTalk from '@sharedInterfaces/IEmployeeTalk';
import EmployeeTalk, { EmployeeTalkGQL } from '@src/Objects/EmployeeTalk';
import { deleteEmployeeTalk, updateEmployeeTalk } from '@store/reducer/employeeTalksReducer';
import store from '@store/store';

import GraphQL from '../graphQL';
import { NotFoundError } from '../NotFoundError';

const q = gql`
query GetEmployeeTalk($employeeTalkId: Int!) {
    employeeTalk(id: $employeeTalkId) ${EmployeeTalkGQL}
}
`;

/**
 * Retrieves an employee talk by employeeTalkId.
 *
 * @param {number} employeeTalkId - The ID of the employee talk to retrieve.
 * @returns {Promise<EmployeeTalk>} A promise that resolves with the retrieved employee talk.
 */
export default async function getEmployeeTalk(employeeTalkId: number): Promise<EmployeeTalk> {
    const variables: OperationVariables = { employeeTalkId };
    return GraphQL.query<{ employeeTalk: IEmployeeTalk }>(q, variables).then((obj) => {
        if (!obj?.employeeTalk) {
            store.dispatch(deleteEmployeeTalk(employeeTalkId));
            throw new NotFoundError(employeeTalkId, EEntityType.EMPLOYEE_TALK);
        }
        const newEmployeeTalk = new EmployeeTalk(obj.employeeTalk);
        store.dispatch(updateEmployeeTalk(newEmployeeTalk));
        return newEmployeeTalk;
    });
}
